// extracted by css-extract-rspack-plugin
export default {"tooltip":"Tooltip-module__tooltip___nXpuN","arrow":"Tooltip-module__arrow____evTt"};